<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="baseView.id"
        recordType="Customer"
        v-if="loaded"
      />
    </template>

    <GcPopupCustomerProductHistoryDtl
      v-if="gcPopupCustomerProductHistoryDtlConfig.visible"
      :setVisible="gcPopupCustomerProductHistoryDtlConfig.visible"
      :hidden="gcPopupCustomerProductHistoryDtlConfig.hidden"
      :setLoading="() => {}"
      :dataObj="gcPopupCustomerProductHistoryDtlConfig.dataModel"
      :filterByCustomer="true"
      :columns="gcPopupCustomerProductHistoryDtlConfig.columns"
      :filters="gcPopupCustomerProductHistoryDtlConfig.filters"
    />

    <div class="css-v2 transaction-list">
      <div class="data-grid-details">
        <GcDataGrid
          :grouping="true"
          :export="true"
          :summary="true"
          :dataSourceConfig="
            screenJson.gridData
              ? screenJson.gridData.gridOptions.dataSource
              : undefined
          "
          :columns="getColumns"
          :valueChangeListners="getListners"
          :childGridColumns="getChildGridColumns"
          :gridToolbar="
            screenJson.gridData ? screenJson.gridData.toolbar : undefined
          "
          :padColumn="true"
          :id="'transaction-list-grid'"
          v-if="loaded && screenJson.gridData"
          ref="transactionListGrid"
          :isEditableGrid="true"
          :showFooter="false"
          :gridOptions="
            screenJson.gridData ? screenJson.gridData.gridOptions : undefined
          "
          :elementAttrClass="'transaction-template'"
          :paging="true"
          :heightPadding="20"
          :rowClick="rowClickCallBack"
          :persistenceKey="persistenceKey"
          :saveGridLayout="true"
          :key="gridKey"
        />
      </div>
    </div>
    <gcPopupSaveLayout
      :visible.sync="getVisibleGridSavePopup"
      :persistenceKey="persistenceKey"
      :showLoading="setLoading"
      :original-columns="[...deepCloneColumns]"
      v-if="getVisibleGridSavePopup"
    />
  </gc-main-layout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import formMixin from "../../_mixins/form.mixin";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import DataGridMixin from "../../_mixins/data-grid.mixin";
import { CustomerService } from "../../_services/api/customers/customer.service";

import { CommonStorage } from "../../_services/storage";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { DataGridState } from "../../_models/data-grid-state";
import gcPopupSaveLayout from "../../popups/data-grid/gc-popup-save-layout.vue";
import { mapGetters } from "vuex";
import DataGridHelpers from "@/_helpers/data-grid/helpers";
const { syncDateFilters } = DataGridHelpers;

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX Log >>> ", arguments);
}

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin, CustomerTabsMixin, DataGridMixin, formMixin],
  components: {
    gcPopupSaveLayout,
  },

  data() {
    return {
      persistenceKey: "customer-product-history-list",
      backButtonRoute: `/customer`,
      CustomerSalesRepresentativeCode: undefined,
      gcPopupCustomerProductHistoryDtlConfig: {},
      model: {
        Code: "",
        Name: "",
      },

      gridOptions: {
        noDataMessage: {
          addNew: {
            class: "no-data",
            title: "No Product History",
            message:
              "Currently there are no product history records for this customer.",
          },
        },
      },
      loaded: false,
      gridKey: new Date().getTime(),
    };
  },
  async beforeMount() {
    const removeState = CommonStorage.getItems("remove_state");

    if (this.persistenceKey) {
      // await DataGridState.checkInDatabase(this.persistenceKey);
      DataGridState.initializeGridViewDefinition(this.persistenceKey, [
        ...this.getColumns,
      ]);
    } else if (removeState === "true") {
      await DataGridState.removeState(this.persistenceKey);
    }
    CommonStorage.saveItems("remove_state", false);
  },
  computed: {
    ...mapGetters({ visibleGridSavePopup: "ui/getVisibleGridSavePopup" }),
    ...mapGetters({
      getTriggerViewDefinitionChange:
        "gridViewDefinition/getTriggerViewDefinitionChange",
    }),
    ...mapGetters({
      getSelectedDefinitionByKey:
        "gridViewDefinition/getSelectedDefinitionByKey",
    }),
    getChildGridColumns() {
      return this.screenJson.gridData.childColumns;
    },
    getListners() {
      return this.screenJson.gridData
        ? this.screenJson.gridData.valueChangedEventListners
        : undefined;
    },
    screenJson() {
      var config = {
        title: "Customers",

        exportFileName: "Customers Product History",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerProductHistoryList",
              filter: [["CustomerCode", "=", this.baseView.id]],
              serverPaging: true,
              allowGrouping: false,
              select: [
                "DiscountPcnt",
                "FXCurrency",
                "InvoiceNo",
                "MovementDate",
                "PriceGroupId",
                "PriceGroupShortDescription",
                "ProductCode",
                "ProductDescription1",
                "SalesOrder",
                "SalesUM",
                "SalesUMQty",
                "SalesUMStandardCost",
                "UnitPriceBase",
                "UnitPriceFX",
                "CustomerCode",
                "ExTotalBase",
                "TaxBase",
                "IncTotalBase",
                "ExTotalFX",
                "TaxFX",
                "IncTotalFX",
                "SalesUMStandardPriceBase",
                "SalesUMStandardPriceFX",
                "GrossProfitPcnt",
                "GrossProfitBase",
              ],
            },

            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Product History",
                message:
                  "There are no product history records for this customer.",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            filterOnEnter: true,
          },
          columns: this.getColumns,
        },
      };

      return config;
    },

    getColumns() {
      return [
        {
          screenField: "Product",
          filterIndex: 1,
        },
        {
          screenField: "Date",
          sortOrder: "desc",
          dataField: "MovementDate",
          label: "Date",
        },
        {
          screenField: "Invoice",
          dataField: "InvoiceNo",
          label: "Invoice #",
          filterIndex: 2,
          filterDataField: "InvoiceNo",
          filterLabel: "Invoice #",
          type: "Integer",
          hyperlink: {
            url: `invoice/review/__ID__`,
            dataField: "InvoiceNo",
            target: "_blank",
          },
          width: ColumnWidth.InvoiceNumber.width,
          minWidth: ColumnWidth.InvoiceNumber.minWidth,
        },
        {
          screenField: "Invoice",
          label: "Sales Order #",
          dataField: "SalesOrder",
          filterLabel: "Sales Order #",
          filterIndex: 3,
          filterDataField: "SalesOrder",
          type: "Integer",
          width: ColumnWidth.SalesOrderNumber.width,
          minWidth: ColumnWidth.SalesOrderNumber.minWidth,
          hyperlink: {
            url: `sales-order/review/__ID__`,
            dataField: "SalesOrder",
            target: "_blank",
          },
        },
        {
          screenField: "SalesUM",
          label: "Sales UM",
          dataField: "SalesUM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          width: ColumnWidth.UnitOfMeasure.width,
        },
        {
          screenField: "SalesUMQty",
          dataField: "SalesUMQty",
          label: "Sales UM Qty",
          minWidth: ColumnWidth.Quantity.minWidth,
          width: ColumnWidth.Quantity.width,
        },
        {
          dataField: "FXCurrency",
          label: "Currency",
          minWidth: ColumnWidth.CurrencyCode.minWidth,
          width: ColumnWidth.CurrencyCode.width,
        },
        {
          dataField: "SalesUMStandardCost",
          label: "Sales UM Std Cost (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "SalesUMStandardPriceBase",
          label: "Sales UM Std Price (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "SalesUMStandardPriceFX",
          label: "Sales UM Std Price (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "UnitPriceFX",
          label: "Sales UM Price (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "UnitPriceBase",
          label: "Sales UM Price (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          screenField: "DiscountPercent",
          label: "Disc",
          dataField: "DiscountPcnt",
          visible: false,
          showInColumnChooser: true,
        },
        {
          dataField: "ExTotalFX",
          label: "Ex Total (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "TaxFX",
          label: "Tax (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "IncTotalFX",
          label: "Inc Total (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "ExTotalBase",
          label: "Ex Total (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "TaxBase",
          label: "Tax (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "IncTotalBase",
          label: "Inc Total (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "GrossProfitPcnt",
          label: "GP %",
          type: "Decimal",
          format: "Decimal-16-2P",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "GrossProfitBase",
          label: "GP (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          screenField: "PriceGroup",
          gridDataField: "PriceGroupId",
          cellTemplateRecord: {
            primary: [
              {
                dataField: "PriceGroupShortDescription",
              },
            ],
            secondary: [
              {
                dataField: "PriceGroupId",
              },
            ],
          },
          exportFields: [
            {
              dataField: "PriceGroupId",
              label: "Price Group Code",
            },
            {
              dataField: "PriceGroupShortDescription",
              label: "Price Group Description",
            },
          ],
        },
        {
          screenField: "ProductCategory1",
          filterLabel: "Product Category 1",
          filterDataField: "ProductCategory1",
          filterIndex: 9,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "ProductCategory2",
          filterLabel: "Product Category 2",
          filterDataField: "ProductCategory2",
          filterIndex: 10,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "ProductCategory3",
          filterLabel: "Product Category 3",
          filterDataField: "ProductCategory3",
          filterIndex: 11,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "ProductCategory4",
          filterLabel: "Product Category 4",
          filterDataField: "ProductCategory4",
          filterIndex: 12,
          visible: false,
          showInColumnChooser: false,
        },
      ].concat(this.getAttributeColumns(12, false, false));
    },
    getVisibleGridSavePopup: {
      get() {
        return this.visibleGridSavePopup;
      },
      set(val) {
        this.$store.dispatch("ui/setVisibleGridSavePopup", val);
      },
    },

    deepCloneColumns() {
      return JSON.parse(JSON.stringify(this.getColumns));
    },
  },
  mounted() {
    logDev("mounted ", this.columns);
  },

  async created() {
    CommonStorage.clear("go_back_route");
    this.selectedIndex = this.tabs.findIndex(
      (x) => x.text === "Product History",
    );

    await CustomerService.getByCode(this.baseView.id, ["Code", "Name"]).then(
      async (response) => {
        if (response.data.value.length > 0) {
          this.model.Code = response.data.value[0].Code;
          this.model.Name = response.data.value[0].Name;
        }
      },
    );
    this.loaded = true;
  },
  methods: {
    setLoading(val) {
      this.showLoading(val);
    },
    rowClickCallBack(e) {
      if (e.rowType == "data" && e.column.screenField != "Invoice") {
        const data = e.data;
        this.showCustomerProductHistoryDetail(data);
      }
    },
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
    showCustomerProductHistoryDetail(e) {
      let filterData = undefined;

      if (
        this.$refs["transactionListGrid"] &&
        this.$refs["transactionListGrid"].$refs["gc-filter-panel"] &&
        this.$refs["transactionListGrid"].$refs["gc-filter-panel"].$refs[
          "gc-form"
        ] &&
        this.$refs["transactionListGrid"].$refs["gc-filter-panel"].$refs[
          "gc-form"
        ].$refs["gc-form-comp"]
      ) {
        var formComp =
          this.$refs["transactionListGrid"].$refs["gc-filter-panel"].$refs[
            "gc-form"
          ].$refs["gc-form-comp"];

        if (formComp) {
          const formInstance = formComp.instance;
          if (formInstance) {
            var options = formInstance.option();
            if (options && options.formData) {
              filterData = options.formData;
            }
          }
        }
      }

      let columns = [];
      if (CommonStorage.getItems(this.persistenceKey)) {
        columns = JSON.parse(
          CommonStorage.getItems(this.persistenceKey),
        ).columns;
      }

      this.gcPopupCustomerProductHistoryDtlConfig = {
        visible: true,
        hidden: () => {
          this.gcPopupCustomerProductHistoryDtlConfig.visible = false;
        },
        dataModel: e,
        columns: columns,
        filters: filterData,
      };
    },
  },
  watch: {
    getTriggerViewDefinitionChange: {
      handler(value) {
        if (value) {
          this.$store.dispatch(
            "gridViewDefinition/setTriggerViewDefinitionChange",
            false,
          );

          const selectedDefinition = this.getSelectedDefinitionByKey(
            this.persistenceKey,
          );

          if (selectedDefinition) {
            if (selectedDefinition.GridDefinition) {
              const GridDefinition = JSON.parse(
                selectedDefinition.GridDefinition,
              );
              if (GridDefinition) {
                CommonStorage.saveItems(
                  this.persistenceKey,
                  JSON.stringify(GridDefinition),
                );
              }
            }

            if (selectedDefinition.FilterDefinition) {
              const FilterDefinition = JSON.parse(
                selectedDefinition.FilterDefinition,
              );
              if (FilterDefinition) {
                const syncedFilterDefinition = syncDateFilters(
                  FilterDefinition,
                  this.deepCloneColumns,
                );
                CommonStorage.saveItems(
                  "filter-panel-" + this.persistenceKey,
                  JSON.stringify(syncedFilterDefinition),
                );
              }
            } else {
              CommonStorage.clear("filter-panel-" + this.persistenceKey);
            }

            this.$nextTick(() => {
              if (this.$refs["transactionListGrid"]) {
                this.gridKey = new Date().getTime();
              }
            });
          }
        }
      },
      deep: true,
    },
  },
};
</script>
